import * as THREE from 'three';
import {
    Color,
    PerspectiveCamera,
    OrthographicCamera,
    Mesh,
    // Shape,
    // ExtrudeGeometry,
    BufferAttribute,
    Group,
    MeshLambertMaterial,
    } from "three";

import { mapGetters } from 'vuex';

import { RoundedBoxGeometry } from 'three/examples/jsm/geometries/RoundedBoxGeometry.js';
import { BufferGeometryUtils } from "three/examples/jsm/utils/BufferGeometryUtils";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

export const IfcDisplayMixin = {
    watch: {
        center_model: function(val) {
            // this.centerModel();
          this.centerModelNew(val);
        },
    // 'selected_elements.elements'(val) {
        'filtered_selected_elements'(val) {
          this.setGroupIndicesByIds({name: 'element_selection', ids: val});
        },
        'visible_elements.elements': function(val) {
          // this.scene.remove(this.scene.getObjectByName('visible_group'));
          // this.scene.getObjectByName('visible_group').clear();
          
          // this.removeObjectByName('visible_group');
          // this.scene.add(this.createGeometryGroup({name: 'visible', ids: val, render_order: 0}));
          this.setGroupIndicesByIds({name: 'visible', ids: val});
          // this.raycast_object = this.scene.getObjectByName('visible_group');
          // this.testtest2();
          if (this.projection_type === 'minion') {
            this.loadColliderEnvironment();
          }
          // if (this.center_model) {
          //   this.centerModel();
          // }
          // console.log(this.scene);
        },
        'visible_taktareashapes.taktareashapes'(val) {
          // maybe improve performance when a lot of shapes ???
          if (this.$store.state.ProjectStructure.show_taktareashapes) {
            let ids = Object.keys(this.$store.state.Ultra.taktareashapes);
            for (let i = 0; i < ids.length; i++) {
              let id = ids[i];
              let group = this.scene.getObjectByName(`shape_group_${id}`);
              // let mesh = this.scene.getObjectByName(`shape_unstaged_${id}`);
              if (group) {
                if (val.includes(id) || val.includes(parseInt(id))) {
                  group.visible = true;
                  // mesh.visible = true;
                } else {
                  group.visible = false;
                  // mesh.visible = false;
                }
              }  
            }
          }
        },
        'active_linked_ta_elements.ta_elements'(val) {
          if (this.$store.state.ProjectStructure.show_taktarea_linked_edges) {
            this.setGroupIndicesByIds({name: 'taktarea_elements', ids: val});
          }
        },
        'active_linked_elements.elements'(val) {
          if (this.$store.state.ProjectStructure.show_steps_linked_edges) {
            this.setGroupIndicesByIds({name: 'step_elements', ids: val});
          }
        },
        'active_shapes.taktareashapes'(val) {
            this.setCollectionObjects({collection_name: 'visible_taktareashapes', action: 'set', ids_by_target: {taktareashapes: val}});   
          },
        active_element_ids: function(val) {
            if (this.hide_non_selected) {
              // selected elements have normal color, all non selected are not visible
              let ids = val;
              if (!this.active_tree_element_spatial) {
                ids = Object.keys(this.$store.state.ProjectStructure.project_elements);
              }
              this.setGroupIndicesByIds({name: 'visible', ids: ids});
              // this.raycast_object = this.scene.getObjectByName('visible_group'); //nescessary?
              
            } else {
              let ids = val;
              if (!this.active_tree_element_spatial) {
                ids = [];
              }
              this.setGroupIndicesByIds({name: 'selected', ids: ids});
              // this.raycast_object = this.scene.getObjectByName('visible_group');
            }
        },
        hide_non_selected: function(val) {
          if (!this.active_tree_element) {
            if (val) {
              this.setGroupIndicesByIds({name: 'visible', ids: this.active_element_ids});
              this.setGroupIndicesByIds({name: 'selected', ids: []});
              // this.raycast_object = this.scene.getObjectByName('visible_group'); //nescessary?
            } else {
              this.setGroupIndicesByIds({name: 'visible', ids: this.visible_elements.elements});
              this.setGroupIndicesByIds({name: 'selected', ids: this.active_element_ids});
              // this.raycast_object = this.scene.getObjectByName('visible_group'); //nescessary?
            }
          }
        },
        show_invisible: function(val) {
          let group = this.scene.getObjectByName('transparent_group');
            if (val) {
              // this.scene.add(this.createTransparentGroup());
              group.visible = true;
            } else {
              // this.removeObjectByName('transparent_group');
              group.visible = false;
            }
        },
        // active_tree_element_process(val, oldVal) {
        //   if (oldVal.type === 'taktareashapes') {
        //     this.removeObjectByName('selected_shape');
        //   }
        //   else if (val.type === 'taktareashapes') {
        //     if (val.path.length === 0) {
        //       this.drawing_object = JSON.parse(JSON.stringify(val));
        //       this.startDrawing();
        //     } else {
        //       //draw shape
        //       let shape = new Shape();
        //       val.path.forEach((point, index) => {
        //           if (index === 0) {
        //               shape.moveTo(point.x, point.y);
        //             } else {
        //                 shape.lineTo(point.x, point.y);
        //               }
        //             });
        //       let geometry = new ExtrudeGeometry(shape, { depth: val.height, steps: 1, bevelEnabled: false});
        //       geometry.translate(0,0,val.lower_level);
        //       geometry.rotateX(- Math.PI / 2);
        //       let mesh = new Mesh(geometry, this.shape_material);
        //       mesh.name = "selected_shape";
        //       this.scene.add(mesh);
        //       //match elements
        //       this.active_element_ids = this.getGeometrySelection(this.visible_normal_group.children, val);
        //     }
        //   }
        //   else if (val.type === 'taktareas') {
        //     this.active_element_ids = val.elements;
        //   }
        // },
        active_tree_element_spatial: function(val) {
          if (val) {
            if (val.type === 'elements') {
              this.active_element_ids = [val.id];
            }
            else {
              let children_ids = this.getAllChildObjectIds({
                parent: val,
                tree_type: 'spatial',
                targets: ['elements'],
              });
              this.active_element_ids = children_ids.elements;
            }
            // else if (val.type === 'element_wrapper') {
            //   this.active_element_ids = val.element_ids;
            // }
            // else {
            //   let children_ids = this.getAllChildElements({
            //     parent_type: val.type,
            //     parent_id: val.id
            //   });
            //   this.active_element_ids = children_ids;
            // }
          } else {
            this.active_element_ids = [];
            // if (this.drawing) {
            //   this.endDrawing();
            // }
          }
        },
        show_edges: function (val) {
          if (val) {
            this.visible_edges_group.visible = true;
          } else {
            this.visible_edges_group.visible = false;
          }
        },
        show_edges_only: function (val) {
          if (val) {
            this.all_normal_groups.visible = false;
            this.visible_edges_group.visible = true;
            this.selected_edges_group.visible = true;
            this.highlighted_edges_group.visible = true;
            // this.raycast_object = this.visible_edges_group;
            this.raycast_object = this.edges_helper_group;
            

          } else {
            this.all_normal_groups.visible = true;
            this.visible_edges_group.visible = this.show_edges;
            this.selected_edges_group.visible = false;
            this.highlighted_edges_group.visible = false;
            this.raycast_object = this.visible_normal_group;
          }
          // reset element visibilty
          if (this.hide_non_selected) {
            this.setGroupIndicesByIds({name: 'visible', ids: this.active_element_ids});
            this.setGroupIndicesByIds({name: 'selected', ids: []});
          } else {
            this.setGroupIndicesByIds({name: 'visible', ids: this.visible_elements.elements});
            this.setGroupIndicesByIds({name: 'selected', ids: this.active_element_ids});
          }
        },
        show_orbit_target: function(val) {
          let group = this.scene.getObjectByName('CorporateOrbitTarget');
            if (val) {
              group.visible = false;
            } else {
              group.visible = true;
            }
        },
      },
    computed: {
      ...mapGetters('ProjectStructure', [
        'isSet1inSet2',
      ]),
      filtered_selected_elements(){
        if (this.$store.state.ProjectStructure.filter.spatial.active) {
          const res = this.isSet1inSet2({
            set1: { type: 'ids_by_target', value: { elements: this.$store.state.ProjectStructure.selected_elements.elements }},
            set2: { type: 'ids_by_target', value: { elements: this.$store.state.ProjectStructure.filter.spatial.objects.elements }},
            targets: ['elements'],
          });
          return res.result_by_target.elements.contained_ids;
        }
        return this.$store.state.ProjectStructure.selected_elements.elements;
      }
    },
    methods: {
    testtest() {
      const geometry2 = new THREE.BoxGeometry( 1, 1, 1 );
      const material = new THREE.MeshBasicMaterial( {color: 0x00ff00} );
      const cube = new THREE.Mesh( geometry2, material );
      this.scene.add( cube );

      let geometry = {
        points_x: [0,1,1,0],
        points_y: [0,0,1,1],
        extrude_value: 2,
      }
      let points = [];
      for (let i = 0; i < geometry.points_x.length; i++) {
          points.push( new THREE.Vector2( geometry.points_x[i], geometry.points_y[i] ) );
        }
        let shape = new THREE.Shape( points );
      
        let geom = new THREE.ExtrudeGeometry(shape, { depth: geometry.extrude_value, steps: 1, bevelEnabled: false});
      //   geom.translate(geometry.offset);
        geom.rotateX(- Math.PI / 2);
        let mesh = new THREE.Mesh(geom, this.shape_material);
        this.scene.add( mesh );
    },
    testtest2() {
      const geometry = new THREE.BufferGeometry();
      const vertices = [0,0,0,1,1,1,2,2,2];

      // const sprite = new THREE.TextureLoader().load( 'textures/sprites/disc.png' );

      // for ( let i = 0; i < 10000; i ++ ) {

      //   const x = 2000 * Math.random() - 1000;
      //   const y = 2000 * Math.random() - 1000;
      //   const z = 2000 * Math.random() - 1000;

      //   vertices.push( x, y, z );

      // }

      geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( vertices, 3 ) );

      // material = new THREE.PointsMaterial( { size: 35, sizeAttenuation: true, map: sprite, alphaTest: 0.5, transparent: true } );
      let material = new THREE.PointsMaterial();
      material.color.setHSL( 1.0, 0.3, 0.7 );

      const particles = new THREE.Points( geometry, material );
      this.scene.add( particles );
    },
    centerModelNew() {
      if (this.center_model) {

      let min_x = false;
      let min_y = false;
      let min_z = false;
      let max_x = false;
      let max_y = false;
      let max_z = false;
      let group = this.visible_normal_group;
      for (let k = 0; k < group.children.length; k++) {
        // let el = this.visible_normal_group.children[k];
        let ind_arr = group.children[k].geometry.index.array;
        let pos_arr = group.children[k].geometry.attributes.position.array;
        
        for (let i = 0; i < ind_arr.length; i++) {
          let index = ind_arr[i];  

          let x = pos_arr[index*3];
          let z = pos_arr[index*3+1];
          let y = pos_arr[index*3+2];

          if (!min_x) {
            min_x = x;
          } else {
            min_x = Math.min(min_x, x);
          }
          if (!min_y) {
            min_y = y;
          } else {
            min_y = Math.min(min_y, y);
          }
          if (!min_z) {
            min_z = z;
          } else {
            min_z = Math.min(min_z, z);
          }
          if (!max_x) {
            max_x = x;
          } else {
            max_x = Math.max(max_x, x);
          }
          if (!max_y) {
            max_y = y;
          } else {
            max_y = Math.max(max_y, y);
          }
          if (!max_z) {
            max_z = z;
          } else {
            max_z = Math.max(max_z, z);
          }
        }
      }

        this.center_position.x = - (min_x + max_x) / 2;
        this.center_position.y =  (min_y + max_y) / 2;
        this.center_position.z = -min_z;
      } else {

        this.center_position.x = 0;
        this.center_position.y = 0;
        this.center_position.z = 0;

    }
      // center all groups
      let object = this.scene.getObjectByName('all_groups');
      if (object) {
      object.position = this.center_position;
      }
      // center clipping planes
      // hor
      this.stencilPlaneGroup_hor.position.x = this.center_position.x;
      this.stencilPlaneGroup_hor.position.y = this.center_position.y;
      //ver_x
      this.stencilPlaneGroup_ver_x.position.x = this.center_position.x;
      this.stencilPlaneGroup_ver_x.position.z = this.center_position.z;
      // // ver_y
      this.stencilPlaneGroup_ver_y.position.y  = this.center_position.y;
      this.stencilPlaneGroup_ver_y.position.z  = this.center_position.z;
    },

    /**
    * Zooms the camera to fit the visible objects within the scene.
    * @param {THREE.Camera} camera - The camera object from the Three.js scene.
    * @param {THREE.Mesh|THREE.Group|Array} objects - The object(s) to focus on. Can be a single object or an array of objects. e.g. this.all_groups
    * @param {number} baseOffset - The base offset to apply when positioning the camera. Default is 10.
    */
    zoomToVisible(camera, /*objects,*/ baseOffset = 10) {
      // Calculate Minimal & Maximal X/Y/Z Values of visible Elements 
      let min_x = Infinity;
      let min_y = Infinity;
      let min_z = Infinity;
      let max_x = -Infinity;
      let max_y = -Infinity;
      let max_z = -Infinity;
      let group = this.visible_normal_group;
      // let group = objects;
      for (let k = 0; k < group.children.length; k++) {
        let ind_arr = group.children[k].geometry.index.array;
        let pos_arr = group.children[k].geometry.attributes.position.array;
        for (let i = 0; i < ind_arr.length; i++) {
          let index = ind_arr[i];  
          let x = pos_arr[index*3];
          let z = pos_arr[index*3+1];
          let y = pos_arr[index*3+2] * -1;
          
          min_x = Math.min(min_x, x);
          min_y = Math.min(min_y, y);
          min_z = Math.min(min_z, z);
          max_x = Math.max(max_x, x);
          max_y = Math.max(max_y, y);
          max_z = Math.max(max_z, z);
        }

      }
      const boundingBox = new THREE.Box3(
        new THREE.Vector3(min_x, min_y, min_z),
        new THREE.Vector3(max_x, max_y, max_z),
      );

      // Calculate the center point of the bounding box
      const center = boundingBox.getCenter(new THREE.Vector3());
      const size = boundingBox.getSize(new THREE.Vector3());
      // const helper = new THREE.Box3Helper(boundingBox, 0xffff00); // Gelbe Farbe für die BoundingBox
      // this.scene.add(helper);

      // Get the maximum dimension (radius) of the objects
      const maxDim = Math.max(size.x, size.y, size.z);
      const fov = camera.fov * (Math.PI / 180);

      // Calculate the optimal Z position of the camera
      let cameraZ = Math.abs(maxDim / (2 * Math.tan(fov / 2)));

      // Apply a dynamic offset to the camera's Z position
      cameraZ += baseOffset;

      // Calculate the new position of the camera while maintaining the current orientation
      const dir = camera.position.sub(center).normalize();
      const newPosition = dir.multiplyScalar(cameraZ).add(center);

      // Update the camera's position
      camera.position.copy(newPosition);

      // Update the OrbitControls if they exist
      if (this.controls) {
        this.controls.target.copy(center);
        this.controls.update();
      }
      // console.log('zoomed to visible');
    },


        changeCamera(camera_type) {
          let new_camera;

          let fov_y = 75;
          let near = 0.1;
          let far = 2000;

          if (camera_type === 'Ortho') { //Ortho
            // new_camera = new OrthographicCamera( this.size.width / - 2, this.size.width / 2, this.size.height / 2, this.size.height / - 2, 1, 1000);
            let v3_object = this.controls.target; // THREE.Vector3 : positon of the object
            let v3_camera = this.camera.position;

            let line_of_sight = new THREE.Vector3();
            this.camera.getWorldDirection( line_of_sight );

            let v3_distance = v3_object.clone().sub( v3_camera );
            let depth = v3_distance.dot( line_of_sight );  
            
            let aspect = this.size.width / this.size.height;
            let height_ortho = depth * 2 * Math.atan( fov_y*(Math.PI/180) / 2 );
            let width_ortho  = height_ortho * aspect;

            new_camera = new OrthographicCamera(width_ortho/-2, width_ortho/2,height_ortho/2, height_ortho/-2,near, far);
            this.camera_type = 'Ortho';

            new_camera.aspect = aspect;
            new_camera.fov = fov_y;
            
          } else { //3d - perspective
            new_camera = new PerspectiveCamera(fov_y, this.size.width / this.size.height, near, far);
            this.camera_type = '3D';

            // new_camera.position.set(this.camera.position.x,this.camera.position.y,this.camera.position.z);
          }
          // copy old camera
          new_camera.position.copy( this.camera.position ); 
          new_camera.quaternion.copy( this.camera.quaternion ); 

          new_camera.updateMatrix();
          new_camera.updateMatrixWorld(); 

          new_camera.updateProjectionMatrix();

          this.camera = new_camera;

          this.removeObjectByName('camera');
          this.scene.add(this.camera);
          
          this.removeObjectByName('selectionShape', this.camera);
          this.camera.add( this.selectionShape );

          // const geometry = new THREE.BoxGeometry( 1, 1, 1 ); 
          // const material = new THREE.MeshBasicMaterial( {color: 0x00ff00} ); 
          // const cube = new THREE.Mesh( geometry, material ); 
          // this.camera.add( cube );

          let threeCanvas = document.getElementById("three-canvas");
          threeCanvas.tabindex = 0;
          threeCanvas.focus();

          let new_controls = new OrbitControls(this.camera, threeCanvas); 

          this.controls = new_controls;
          this.controls.enableDamping = false;
          this.controls.enablePan = true;
          this.controls.enableRotate = true;
          // this.controls.position0.copy( this.camera.position ); 
          // this.controls.target.copy(this.controls.target);

          // this.controls.reset();

        },
        floorView() {
        this.endFPV();
        this.projection_type = 'Floor View';
        this.camera = new OrthographicCamera( this.size.width / - 2, this.size.width / 2, this.size.height / 2, this.size.height / - 2, 1, 1000);
        this.camera.position.z = 50;
        this.camera.position.y = 0;
        this.camera.position.x = 0;
    
        const threeCanvas = document.getElementById("three-canvas");
        threeCanvas.tabindex = 0;
        threeCanvas.focus();
        //Creates the orbit controls (to navigate the scene)
        this.controls = new OrbitControls(this.camera, threeCanvas);
        this.controls.enableDamping = false;
        this.controls.enablePan = true;
        this.controls.enableRotate = false;
        },
        freeView() {
        this.endFPV();
        this.projection_type = '3D';
        //Creates the camera (point of view of the user)
        this.camera = new PerspectiveCamera(75, this.size.width / this.size.height);
        this.camera.position.z = 30;
        this.camera.position.y = -30;
        this.camera.position.x = -30;
    
        const threeCanvas = document.getElementById("three-canvas");
        threeCanvas.tabindex = 0;
        threeCanvas.focus();
        //Creates the orbit controls (to navigate the scene)
    
        const controls = new OrbitControls(this.camera, threeCanvas);
        controls.enableDamping = false;
        controls.enablePan = true;
        controls.enableRotate = true;
        },
    
        //test fpv
        endFPV() {
        let self = this;
        window.removeEventListener( 'keydown', function ( e ) {
            switch ( e.code ) {
            case 'KeyW': self.fwdPressed = true; break;
            case 'KeyS': self.bkdPressed = true; break;
            case 'KeyD': self.rgtPressed = true; break;
            case 'KeyA': self.lftPressed = true; break;
            case 'Space':
            if ( self.playerIsOnGround ) {
                self.playerVelocity.z = 10.0;
            }  break;
            }
        } );
        window.removeEventListener( 'keyup', function ( e ) {
            switch ( e.code ) {
            case 'KeyW': self.fwdPressed = false; break;
            case 'KeyS': self.bkdPressed = false; break;
            case 'KeyD': self.rgtPressed = false; break;
            case 'KeyA': self.lftPressed = false; break;
            }
            } );
            this.removeObjectByName('minion_mesh');
        },
        startFPV() {
            this.removeObjectByName('highlightmesh');
            this.playerVelocity = new THREE.Vector3();
            this.upVector = new THREE.Vector3( 0, 0, 1 );
            this.tempVector = new THREE.Vector3();
            this.tempVector2 = new THREE.Vector3();
            this.tempBox = new THREE.Box3();
            this.tempMat = new THREE.Matrix4();
            this.tempSegment = new THREE.Line3();
            // camera setup
            this.camera = new PerspectiveCamera( 75, this.size.width / this.size.height, 0.1, 50 );
            this.camera.position.set( 10, 10, - 10 );
            // this.camera.position.set( -3, 3, 0 );
            this.camera.far = 100;
            this.camera.updateProjectionMatrix();
            // window.camera = this.camera;
      
            // this.controls.maxPolarAngle = Math.PI;
            // this.controls.minDistance = 1e-4;
            // this.controls.maxDistance = 1e-4;
      
            this.clock = new THREE.Clock();
      
            let threeCanvas = document.getElementById("three-canvas");
            threeCanvas.tabindex = 0;
            threeCanvas.focus();
            this.controls = new OrbitControls( this.camera, threeCanvas );
      
            this.loadColliderEnvironment();
      
            // character
            this.player = new Mesh(
              new RoundedBoxGeometry( 1.0, 1.0, 2.0, 10, 0.5 ),
              new THREE.MeshStandardMaterial()
            );
            this.player.name = "minion_mesh";
            this.player.geometry.translate( 0, 0, 0.5 );
            this.player.capsuleInfo = {
              radius: 0.5,
              segment: new THREE.Line3( new THREE.Vector3(), new THREE.Vector3( 0, 0, 1.0 ) )
            };
            this.player.castShadow = true;
            this.player.receiveShadow = true;
            this.player.material.shadowSide = 2;
            this.scene.add( this.player );
            this.reset();
            this.projection_type = 'minion';
      
            let self = this;
            self.$socket.emit('update_minion', self.project_id, self.getUserLiveSync.id, self.player.position);
      
            this.$socket.on('update_minion_room', (id, position) => {
      
              if (id !== self.getUserLiveSync.id) {
                if ( !self.other_players[id] ) {
                  // character
                  self.other_players[id] = new Mesh(
                    new RoundedBoxGeometry( 1.0, 1.0, 2.0, 10, 0.5  ),
                    new THREE.MeshStandardMaterial()
                  );
                  self.other_players[id].name = "minion_mesh" + id;
                  self.other_players[id].geometry.translate( 0, 0, 0.5 );
                  self.other_players[id].capsuleInfo = {
                    radius: 0.5,
                    segment: new THREE.Line3( new THREE.Vector3(), new THREE.Vector3( 0, 0.0, 1.0 ) )
                  };
                  self.other_players[id].castShadow = true;
                  self.other_players[id].receiveShadow = true;
                  self.other_players[id].material.shadowSide = 2;
                  this.scene.add( self.other_players[id] );
                  this.reset();
                }
                self.other_players[id].position = position;
              }
            });
      
            window.addEventListener( 'keydown', function ( e ) {
              self.$socket.emit('update_minion', self.project_id, self.getUserLiveSync.id, self.player.position);
              switch ( e.code ) {
                case 'KeyW': self.fwdPressed = true; break;
                case 'KeyS': self.bkdPressed = true; break;
                case 'KeyD': self.rgtPressed = true; break;
                case 'KeyA': self.lftPressed = true; break;
                case 'Space': 
                if ( self.playerIsOnGround ) {
                  self.playerVelocity.z = 10.0;
                }  break;
              }
            } );
            window.addEventListener( 'keyup', function ( e ) {
              switch ( e.code ) {
                case 'KeyW': self.fwdPressed = false; break;
                case 'KeyS': self.bkdPressed = false; break;
                case 'KeyD': self.rgtPressed = false; break;
                case 'KeyA': self.lftPressed = false; break;
              }
              } );
      },
      loadColliderEnvironment() {
        this.removeObjectByName('collider_mesh');
      
        let geometries = [];
        this.scene.getObjectByName('visible_group').children.forEach(mesh => {
          geometries.push(mesh.geometry.clone());
        });
        if (geometries.length !== 0) {
          let collider_geometry = BufferGeometryUtils.mergeBufferGeometries(geometries);
          collider_geometry.computeBoundsTree();
          this.collider = new Mesh( collider_geometry );
          this.collider.material.wireframe = true;
          this.collider.material.opacity = 0.5;
          this.collider.material.transparent = true;
          this.collider.name = 'collider_mesh';
          this.collider.visible = false;
          this.collider.position = this.center_position;
          this.collider.rotateX( Math.PI / 2);
          this.scene.add( this.collider );
        }
      
      },
      reset() {
          this.playerVelocity.set( 0, 0, 0 );
          this.player.position.set( -3, 0, 7 );
          this.camera.position.sub( this.controls.target );
          this.controls.target.copy( this.player.position );
          this.camera.position.add( this.player.position );
          this.controls.update();
      
      },
      updatePlayer( delta ) {
          this.playerVelocity.z += this.playerIsOnGround ? 0 : delta * this.fpv_params.gravity;
          this.player.position.addScaledVector( this.playerVelocity, delta );
      
          // move the player
          let angle = this.controls.getAzimuthalAngle();
          if ( this.fwdPressed ) {
              this.tempVector.set( 0, 1, 0 ).applyAxisAngle( this.upVector, angle );
              this.player.position.addScaledVector( this.tempVector, this.fpv_params.playerSpeed * delta );
      
          }
      
          if ( this.bkdPressed ) {
      
              this.tempVector.set( 0, -1, 0 ).applyAxisAngle( this.upVector, angle );
              this.player.position.addScaledVector( this.tempVector, this.fpv_params.playerSpeed * delta );
      
          }
      
          if ( this.lftPressed ) {
      
              this.tempVector.set( - 1, 0, 0 ).applyAxisAngle( this.upVector, angle );
              this.player.position.addScaledVector( this.tempVector, this.fpv_params.playerSpeed * delta );
      
          }
      
          if ( this.rgtPressed ) {
      
              this.tempVector.set( 1, 0, 0 ).applyAxisAngle( this.upVector, angle );
              this.player.position.addScaledVector( this.tempVector, this.fpv_params.playerSpeed * delta );
      
          }
      
          this.player.updateMatrixWorld();
      
          // adjust player position based on collisions
          let capsuleInfo = this.player.capsuleInfo;
          this.tempBox.makeEmpty();
          this.tempMat.copy( this.collider.matrixWorld ).invert();
          this.tempSegment.copy( capsuleInfo.segment );
      
          // get the position of the capsule in the local space of the collider
          this.tempSegment.start.applyMatrix4( this.player.matrixWorld ).applyMatrix4( this.tempMat );
          this.tempSegment.end.applyMatrix4( this.player.matrixWorld ).applyMatrix4( this.tempMat );
      
          // get the axis aligned bounding box of the capsule
          this.tempBox.expandByPoint( this.tempSegment.start );
          this.tempBox.expandByPoint( this.tempSegment.end );
      
          this.tempBox.min.addScalar( - capsuleInfo.radius );
          this.tempBox.max.addScalar( capsuleInfo.radius );
      
          this.collider.geometry.boundsTree.shapecast( {
      
              intersectsBounds: box => box.intersectsBox( this.tempBox ),
      
              intersectsTriangle: tri => {
      
                  // check if the triangle is intersecting the capsule and adjust the
                  // capsule position if it is.
                  let triPoint = this.tempVector;
                  let capsulePoint = this.tempVector2;
      
                  let distance = tri.closestPointToSegment( this.tempSegment, triPoint, capsulePoint );
                  if ( distance < capsuleInfo.radius ) {
      
                      let depth = capsuleInfo.radius - distance;
                      let direction = capsulePoint.sub( triPoint ).normalize();
      
                      this.tempSegment.start.addScaledVector( direction, depth );
                      this.tempSegment.end.addScaledVector( direction, depth );
      
                  }
      
              }
      
          } );
      
          // get the adjusted position of the capsule collider in world space after checking
          // triangle collisions and moving it. capsuleInfo.segment.start is assumed to be
          // the origin of the player model.
          let newPosition = this.tempVector;
          newPosition.copy( this.tempSegment.start ).applyMatrix4( this.collider.matrixWorld );
      
          // check how much the collider was moved
          let deltaVector = this.tempVector2;
          deltaVector.subVectors( newPosition, this.player.position );
      
          // if the player was primarily adjusted vertically we assume it's on something we should consider ground
          this.playerIsOnGround = deltaVector.z > Math.abs( delta * this.playerVelocity.z * 0.25 );
      
          let offset = Math.max( 0.0, deltaVector.length() - 1e-5 );
          deltaVector.normalize().multiplyScalar( offset );
      
          // adjust the player model
          this.player.position.add( deltaVector );
      
          if ( ! this.playerIsOnGround ) {
      
              deltaVector.normalize();
              this.playerVelocity.addScaledVector( deltaVector, - deltaVector.dot( this.playerVelocity ) );
      
          } else {
      
              this.playerVelocity.set( 0, 0, 0 );
      
          }
      
          // adjust the camera
          this.camera.position.sub( this.controls.target );
          this.controls.target.copy( this.player.position );
          this.camera.position.add( this.player.position );
      
          // if the player has fallen too far below the level reset their position to the start
          if ( this.player.position.z < - 25 ) {
      
              this.reset();
      
          }
      
      },
      //end test fpv
      removeObjectByName(object_name, from) {
        let parent
        if (from) {
          parent = from;
        } else {
          parent = this.scene;
        }
        let object = this.scene.getObjectByName(object_name);
        if (object) {
          if (object.type === 'Mesh') {
            object.geometry.dispose();
            object.material.dispose();
            parent.remove(object);
            this.renderer.renderLists.dispose();
          }
          else if (object.type === 'Group') {
            object.children.forEach(child => {
              // mesh.geometry.dispose();
              // mesh.material.dispose();
              // recursion
              this.removeObjectByName(child.name, object)
            });
            parent.remove(object);
            this.renderer.renderLists.dispose();
          }
        }
      },
      setGroupIndicesByIds(payload) {
        // let start = new Date().getTime();
        // initialize mesh indices
        // edges
        let handle_edges = false;
        if (['visible', 'element_selection', 'step_elements', 'taktarea_elements'].includes(payload.name) || this.show_edges_only) {
          handle_edges = true;
        }
        let mesh_indices_edges = {};

        if (handle_edges) {
          for (let i = 0; i < this.edges_mesh_names.length; i++) {
            mesh_indices_edges[`${payload.name}${this.edges_mesh_names[i]}`] = [];
          }
          // remove unstaged
          this[`edges_unstaged_ids`].forEach(id => {
            this.scene.getObjectByName(`edges_unstaged_${id}`).visible = false;
          });
        }

        // edges helper -> check performance!

        let handle_edges_helper = false;
        if (this.show_edges_only && payload.name === 'visible') {
          handle_edges_helper = true;
        }
        let mesh_indices_edges_helper = {};
        if (handle_edges_helper) {
          for (let i = 0; i < this.edges_mesh_names.length; i++) {
            mesh_indices_edges_helper[`helper${this.edges_mesh_names[i]}`] = [];
          }
        }

        // normal
        let handle_normal = true;
        if (this.show_edges_only || ['element_selection', 'step_elements', 'taktarea_elements'].includes(payload.name)) {
          handle_normal = false;
        }
        let mesh_indices = {};
        if (handle_normal) {
          for (let i = 0; i < this.mesh_names.length; i++) {
            mesh_indices[`${payload.name}${this.mesh_names[i]}`] = [];
          }      
          // remove unstaged
          this[`${payload.name}_unstaged_ids`].forEach(id => {
            this.scene.getObjectByName(`${payload.name}_unstaged_${id}`).visible = false;
          });
          this[`${payload.name}_unstaged_ids`] = [];
        }
        // handle ids
        let unstaged_elements = new Set(this.project.unstaged_elements);
        // let mid1 = new Date().getTime();
        // console.log('mid1: ' + (mid1 - start));
        payload.ids.forEach(id => {
          if (!unstaged_elements.has(parseInt(id))) {
            // normal
            if (handle_normal) {
              let element = this.elements_by_takting_id[id];
              if (element) {
                // element.forEach(subelement => {
                  for (let j = 0; j < element.length; j++) {
                    let subelement = element[j];
                    let sub_arr = subelement.array;
                    let mesh_name = `${payload.name}_normal${subelement.mesh}`;
                    let index_array = mesh_indices[mesh_name];
                    if (!index_array) {
                      index_array = JSON.parse(JSON.stringify(sub_arr));
                    } else {
                      let offset = index_array.length;
                      for (let i = 0; i < sub_arr.length; i++) { 
                        index_array[offset + i] = sub_arr[i];
                      }
                    }
                }
              } 
            }
            // edges
            if (handle_edges) {
              // handle edges
              let element = this.edges_elements_by_takting_id[id];
              if (element) {
                // element.forEach(subelement => {
                  for (let j = 0; j < element.length; j++) {
                    let subelement = element[j];
                    let mesh_name = `${payload.name}_edges${subelement.mesh}`;
                    if (!mesh_indices_edges[mesh_name]) {
                      mesh_indices_edges[mesh_name] = JSON.parse(JSON.stringify(subelement.array));
                    } else {
                      let offset = mesh_indices_edges[mesh_name].length;
                      for (let i = 0; i < subelement.array.length; i++) { 
                        mesh_indices_edges[mesh_name][offset + i] = subelement.array[i];
                      }
                    }
                }
              }   
            }
            // handle edges helper -> check performance !!
            if (handle_edges_helper) {
              let helper_element = this.edges_helper_elements_by_takting_id[id];
              if (helper_element) {
                // element.forEach(subelement => {
                  for (let j = 0; j < helper_element.length; j++) {
                    let subelement = helper_element[j];
                    let mesh_name = `helper_edges${subelement.mesh}`;
                    if (!mesh_indices_edges_helper[mesh_name]) {
                      mesh_indices_edges_helper[mesh_name] = JSON.parse(JSON.stringify(subelement.array));
                    } else {
                      let offset = mesh_indices_edges_helper[mesh_name].length;
                      for (let i = 0; i < subelement.array.length; i++) { 
                        mesh_indices_edges_helper[mesh_name][offset + i] = subelement.array[i];
                      }
                    }
                }
              } 
            }
          } else {
            this.scene.getObjectByName(`${payload.name}_unstaged_${id}`).visible = true;
            this[`${payload.name}_unstaged_ids`].push(id);
            if (handle_edges) {
              this.scene.getObjectByName(`edges_unstaged_${id}`).visible = true;
              this[`edges_unstaged_ids`].push(id);
            }
          }
        });
        // let mid2 = new Date().getTime();
        // console.log('mid2: ' + (mid2 - mid1));
        unstaged_elements = null;
        // Object.keys(mesh_indices).forEach(key => {
        let keys = Object.keys(mesh_indices);
        for (let i = 0; i < keys.length; i++) { // almost no performance boost
          let key = keys[i];
          let mesh = this.scene.getObjectByName(key);
          let mesh_geometry = mesh.geometry;
          let indices = mesh_indices[key];
          // console.log('before');
          mesh_geometry.setIndex(new BufferAttribute(Uint32Array.from(indices), 1));
          // console.log('after');
          if (indices.length !== 0) {
          mesh_geometry.computeBoundsTree(); // performance expensive!

          // mesh_geometry.computeBoundingBox();

          // if (payload.name === 'visible') {
          //   this.removeObjectByName(`boxhelper${mesh.name}`, this.all_groups);
          //   let boxhelper = new THREE.BoxHelper(mesh, 0xffff00);
          //   boxhelper.name = `boxhelper${mesh.name}`;
          //   this.all_groups.add(boxhelper)
          // }
        }
        // });
        }
        // let mid3 = new Date().getTime();
        // console.log('mid3: ' + (mid3 - mid2));
        Object.keys(mesh_indices_edges).forEach(key => {
          let mesh = this.scene.getObjectByName(key);
          let mesh_geometry = mesh.geometry;
          mesh_geometry.setIndex(new BufferAttribute(Uint32Array.from(mesh_indices_edges[key]), 1));
          // if (mesh_indices_edges[key].length !== 0) {
          //   mesh_geometry.computeBoundsTree();
          //   }
        });
        // edges helper -> check performance !! mesh bvh max depth???
        Object.keys(mesh_indices_edges_helper).forEach(key => {
          let mesh = this.scene.getObjectByName(key);
          let mesh_geometry = mesh.geometry;
          mesh_geometry.setIndex(new BufferAttribute(Uint32Array.from(mesh_indices_edges_helper[key]), 1));
          if (mesh_indices_edges_helper[key].length !== 0) {
            mesh_geometry.computeBoundsTree();
            }
        });

        // let mid4 = new Date().getTime();
        // console.log('mid4: ' + (mid4 - mid3));
        if (payload.name === 'visible') {
          this.centerModelNew(this.center_model);
        }
        // let end = new Date().getTime();
        // console.log('duration: ' + (end - start));
        // console.log('----- end group -----');
      },
      createGeometryGroup(payload) {
        let mesh_indices = {};
        let unstaged_meshes = [];
        let meshes = [];
        let mesh_material;
        let new_mesh;
        payload.ids.forEach(id => {
          if (!this.project.unstaged_elements.includes(`${id}`)) {
            let element = this.elements_by_takting_id[id];
            if (element) {
              element.forEach(subelement => {
                if (!mesh_indices[subelement.mesh]) {
                  mesh_indices[subelement.mesh] = JSON.parse(JSON.stringify(subelement.array));
                } else {
                  // mesh_indices[subelement.mesh].push(...JSON.parse(JSON.stringify(subelement.array)));
                  mesh_indices[subelement.mesh] = mesh_indices[subelement.mesh].concat(JSON.parse(JSON.stringify(subelement.array)));
                  // mesh_indices[element.mesh] = mesh_indices[element.mesh].concat(element.array);

                  // let offset = mesh_indices[subelement.mesh].length;
                  // for (let i = 0; i < subelement.array.length; i++) { 
                  //   mesh_indices[subelement.mesh][offset + i] = subelement.array[i];
                  // }
                }
              });
            }
          } else {
            let element = this.$store.state.Ultra.elements[id];
            if (!element.mesh) {
              let new_mesh = this.createGeometryMesh(element.geometry, element.id);
              this.updateUDObject({
                url: [{elements: id}],
                update: {
                  mesh: new_mesh
                }
              });
            }
            
            new_mesh = element.mesh.clone();
            if (payload.material) {
              new_mesh.material = payload.material;
            }
            new_mesh.renderOrder = payload.render_order;

            new_mesh.name = element.mesh.name;
            new_mesh.unstaged = element.mesh.unstaged;
            new_mesh.takting_id = element.mesh.takting_id;

            unstaged_meshes.push(new_mesh);
          }
        });
        Object.keys(mesh_indices).forEach(key => {
          let mesh = this.scene.getObjectByName(key);
          if (payload.material) {
            mesh_material = payload.material;
          } else {
            mesh_material = mesh.material.clone();
          }
          let mesh_geometry = mesh.geometry.clone();
          mesh_geometry.setIndex(new BufferAttribute(Uint32Array.from(mesh_indices[key]), 1));
          mesh_geometry.computeBoundsTree();
          new_mesh = new Mesh(mesh_geometry, mesh_material);
          new_mesh.renderOrder = payload.render_order;
          meshes.push(new_mesh);
        });
      
        let group = new Group();
        group.name = `${payload.name}_group`;
        //center model
        group.position.set(this.center_position.x, this.center_position.y, this.center_position.z);
        // let group = this.scene.getObjectByName('visible_group');
        meshes.forEach(mesh => {
          group.add(mesh);
        });
        unstaged_meshes.forEach(mesh => {
          group.add(mesh);
        });
        group.rotateX( Math.PI / 2);
        return group;
      },
      createTransparentGroup() {
        let group = new Group();
        group.name = 'transparent_group';
        //center model
        group.position.set(this.center_position.x, this.center_position.y, this.center_position.z);
        let material = new MeshLambertMaterial({color: new Color('white')});
        material.opacity = 0.15;
        material.transparent = true;
        this.scene.getObjectByName('original_group').children.forEach(child => {
          let geometry = child.geometry.clone();
          let new_mesh = new Mesh(geometry, material);
          new_mesh.renderOrder = -10;
          group.add(new_mesh);
        });
        group.rotateX( Math.PI / 2);
        return group;
      },
      handleSideButtons(type){
        if(type === 'center-model'){
          this.center_model = !this.center_model;
          this.side_buttons[0].clicked = !this.side_buttons[0].clicked;
        } else if(type === 'show-invisble-elements'){
          // an / aus Indikatior
          this.show_invisible = !this.show_invisible;
          this.side_buttons[1].icon = this.show_invisible ? 'visibility-on' : 'visibility-off';
          this.side_buttons[1].clicked = !this.side_buttons[1].clicked;
        } else if(type === 'presentation-mode'){
          this.side_buttons[2].clicked = !this.side_buttons[2].clicked;
        } else if(type === 'sections-horizontal'){
          this.show_section_hor = !this.show_section_hor;
          this.side_buttons[3].clicked = !this.side_buttons[3].clicked;
        } else if(type === 'sections-vertical-x'){
          this.show_section_ver_x = !this.show_section_ver_x;
          this.side_buttons[4].clicked = !this.side_buttons[4].clicked;
        } else if(type === 'sections-vertical-y'){
          this.show_section_ver_y = !this.show_section_ver_y;
          this.side_buttons[5].clicked = !this.side_buttons[5].clicked;
        } else if(type === 'zoom-to-visible'){
          this.zoomToVisible(this.camera);
        } else if(type === 'toggle-orbit-target'){
          this.show_orbit_target = !this.show_orbit_target;
          this.side_buttons[7].clicked = !this.side_buttons[7].clicked;
        }
      },
      activateModeByIndex(index) {
        if (index === 1) {
          this.activatePresentationModeNormal()
        } else if (index === 2) {
          this.activatePresentationModeBoth()
        } else if (index === 3) {
          this.activatePresentationModeOnlyEdges()
        }
      },
      activatePresentationModeNormal() {
        this.show_edges = false
        this.show_edges_only = false
        this.side_buttons[2].selected_button = 2;
        this.side_buttons[2].icon = 'cube-negative';
      },

      activatePresentationModeBoth() {
        this.show_edges = true
        this.show_edges_only = false
        this.side_buttons[2].selected_button = 3;
        this.side_buttons[2].icon = 'cube-top';
      },

      activatePresentationModeOnlyEdges() {
        this.show_edges = true
        this.show_edges_only = true
        this.side_buttons[2].selected_button = 4;
        this.side_buttons[2].icon = 'cube';
      },
    }
}